import linkIcon from "components/icons/link_desktop.svg";
import embedIcon from "components/icons/embed_desktop.svg";
import RedditIcon from "components/icons/reddit_desktop.svg";
import TwitterIcon from "components/icons/twitter_desktop.svg";
import DiscordIcon from "components/icons/discord_desktop.svg";

export const getShareMenuItems = (onShareClick: (label: string) => void) => {
  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: linkIcon,
          title: "Copy Link",
          onClick: () => onShareClick("Copy Link")
        },
        {
          icon: embedIcon,
          title: "Embed",
          onClick: () => onShareClick("Embed")
        }
      ]
    },
    {
      groupName: "Social Share",
      groupMobileName: "Social Share",
      items: [
        {
          icon: RedditIcon,
          title: "Reddit",
          onClick: () => onShareClick("Reddit")
        },
        {
          icon: TwitterIcon,
          title: "Twitter",
          onClick: () => onShareClick("Twitter")
        },
        {
          icon: DiscordIcon,
          title: "Discord",
          onClick: () => onShareClick("Discord")
        }
      ]
    }
  ];
};
